import { ContactInformation } from 'src/components/SubNavigation/components/Contact';
import { ExtendedAddress, Principal } from 'src/types/AddMerchant/merchantInfo';

const buildContact = (principals: Partial<Principal>[] | null = []): ContactInformation[] => {
    return (
        principals?.map((principal) => {
            const {
                firstName = '',
                lastName = '',
                email = '',
                mobileNumber = '',
                telephoneNumber = '',
                addresses = [],
                isBillingContact = false,
            } = principal;

            const address: ExtendedAddress | null = addresses.length
                ? (addresses[0] as ExtendedAddress)
                : null;

            const country = address
                ? [
                      address.addressLine1,
                      address.addressLine2,
                      address.city,
                      address.county,
                      address.country,
                      address.eircode,
                  ]
                      .filter((field) => {
                          return field && field.trim() !== '';
                      })
                      .join(', ')
                : '';

            return {
                firstName,
                lastName,
                email,
                mobilePhoneNumber: mobileNumber.length > 0 ? mobileNumber : telephoneNumber,
                country,
                isBillingContact,
            };
        }) ?? []
    );
};

export default buildContact;
